import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=c61c99b8&scoped=true"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61c99b8",
  null
  
)

export default component.exports